import PropTypes from 'prop-types';
import React from 'react';

export default function SimpleButton(props) {
    const handleClick = (e) => {
        e.stopPropagation();
        props.action();
    };

    return (
        <button
            type="button"
            className={`sg-button-primary appActions-learn ${props.className || ''}`}
            onClick={handleClick}
            disabled={props.isDisabled}
        >
            {props.label}
        </button>
    );
}

SimpleButton.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
};
